import { $t } from '@/i18n';
import { computed, inject, onBeforeMount, onMounted, onUnmounted } from '@vue/composition-api';
import { INJECT_UICORE_BUS, INJECT_UICORE_RENDERER } from '@tencent/ui-core/lib/utils/consts';
import { waitForRendererMounted } from '@/utils/global/api';
import { runtimeHook } from '@/hooks/runtimeHook';
const createdEvent = {
    id: 'created',
    name: $t('k_dc969d37'),
    desc: $t('k_2cda9ec3'),
};
const rendererMountedEvent = {
    id: 'rendererMounted',
    name: $t('k_81ab3892'),
    desc: $t('k_260b0ada'),
    arguments: [
        { type: 'any', description: $t('k_f2f7a633') },
    ],
};
const allDataSourcesReadyEvent = {
    id: 'allDataSourcesReady',
    name: $t('k_4b0e58ee'),
    desc: $t('k_be520a20'),
    arguments: [
        { type: 'any', description: $t('k_f2f7a633') },
    ],
};
const destroyedEvent = {
    id: 'destroyed',
    name: $t('k_503bf855'),
    desc: '',
};
// 页面片相关事件
export const EVENTS = [
    createdEvent,
    rendererMountedEvent,
    allDataSourcesReadyEvent,
    destroyedEvent,
];
// 页面片相关事件触发逻辑
export const usePageletEvent = ({ emit }) => {
    const uc = inject(INJECT_UICORE_BUS, null);
    const renderer = inject(INJECT_UICORE_RENDERER, null);
    const isDesignMode = computed(() => uc?.isDesignMode);
    onBeforeMount(() => {
        if (isDesignMode.value)
            return;
        // 初始化
        emit(createdEvent.id);
        // 数据源就绪
        const sources = renderer?.sources;
        if (sources) {
            const promises = [];
            Object.values(sources).forEach((source) => {
                promises.push(source.waitForReady());
            });
            Promise.all(promises)
                .then(() => runtimeHook.pageBeforeAllDataSourcesReady.promise(renderer))
                .then(() => {
                emit(allDataSourcesReadyEvent.id, renderer);
            });
        }
    });
    onMounted(async () => {
        if (isDesignMode.value)
            return;
        await waitForRendererMounted(renderer);
        emit(rendererMountedEvent.id, renderer);
    });
    onUnmounted(() => {
        if (isDesignMode.value)
            return;
        // 销毁
        emit(destroyedEvent.id);
    });
};
